/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Tlm_2Inputs */

const en_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data_layer`)
};

const ar_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طبقة البيانات`)
};

const bn_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data_layer`)
};

const de_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data_layer`)
};

const es_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`capa_datos`)
};

const fr_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`couche_données`)
};

const pt_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`camada de dados`)
};

const zh_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据层`)
};

const tr_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`veri_katmanı`)
};

const ru_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`слой_данных`)
};

const pl_svc_backend_development_tlm_2 = /** @type {(inputs: Svc_Backend_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`warstwa_danych`)
};

/**
* | output |
* | --- |
* | "data_layer" |
*
* @param {Svc_Backend_Development_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_tlm_2 = /** @type {((inputs?: Svc_Backend_Development_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_tlm_2(inputs)
	if (locale === "bn") return bn_svc_backend_development_tlm_2(inputs)
	if (locale === "de") return de_svc_backend_development_tlm_2(inputs)
	if (locale === "es") return es_svc_backend_development_tlm_2(inputs)
	if (locale === "fr") return fr_svc_backend_development_tlm_2(inputs)
	if (locale === "pt") return pt_svc_backend_development_tlm_2(inputs)
	if (locale === "zh") return zh_svc_backend_development_tlm_2(inputs)
	if (locale === "tr") return tr_svc_backend_development_tlm_2(inputs)
	if (locale === "ru") return ru_svc_backend_development_tlm_2(inputs)
	if (locale === "pl") return pl_svc_backend_development_tlm_2(inputs)
	return en_svc_backend_development_tlm_2(inputs)
});
export { svc_backend_development_tlm_2 as "svc_backend-development_tlm_2" }